import React from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Logo, Title, Wrapper } from "./styles";
import LogoImg from "../../assets/icons/icon-logo-remar.svg";
var LogoComponent = function (_a) {
    var logo = _a.logo, title = _a.title, _b = _a.showLargeLogo, showLargeLogo = _b === void 0 ? true : _b;
    var theme = useTheme();
    var history = useHistory();
    var isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    return (React.createElement(Wrapper, { marginTop: isMobile ? "25px" : "0px", "$big": showLargeLogo },
        logo ? logo : React.createElement(Logo, { src: LogoImg, alt: "ReMar Logo", onClick: function () { return history.push("/"); } }),
        title && React.createElement(Title, { variant: "h1" }, title)));
};
export default LogoComponent;
//# sourceMappingURL=LogoComponent.js.map